import React, { useEffect, useState } from "react";
import { CalendarPickerInput, PrimaryButton } from "@cadmakers-ui/core";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { endpoints } from "../../..";
import { ApiRequest, DateDisplay, useShowSnack } from "../../../../Common";

export type Props = {
  feedbackCode: string;
  dueDate?: Date;
  isOpen: boolean;
  toggleModal: () => void;
  onChange: (feedbackCode: string, newDueDate: Date | undefined) => void;
};

export const DueDateDisplayModal = (props: Props) => {
  const [selectedDueDate, setSelectedDueDate] = useState<Date | undefined>(props.dueDate);
  const [datePickerActual, setDatePickerActual] = useState<Date>(
    props.dueDate == null ? new Date() : props.dueDate
  );
  const [changeDueDateLock, setChangeDueDateLock] = useState(false);

  const showSnack = useShowSnack();

  useEffect(() => {
    setSelectedDueDate(props.dueDate);
    setDatePickerActual(props.dueDate == null ? new Date() : props.dueDate);
  }, [props.dueDate]);

  const showPostSetDueDateSnackbar = (dueDate: Date | undefined) => {
    const label = `Set feedback due date to "${
      dueDate == null ? "unset" : dueDate.toLocaleDateString()
    }"`;
    showSnack("FEEDBACK_DUE_DATE", {
      label,
      timeout: 2000
    });
  };

  const showErrorSnackbar = (errorCode: number, errorDescription: string) => {
    showSnack("FEEDBACK_DUE_DATE", {
      label: `Failed to set feedback due date: ${errorDescription} (Error Code ${errorCode})`,
      timeout: 5000
    });
  };

  const onEditDueDate = (dueDate: Date | undefined) => {
    if (changeDueDateLock) {
      return;
    }

    setChangeDueDateLock(true);

    const body = {
      DueDate: dueDate
    };

    ApiRequest.fromPath(endpoints.feedback.dueDate(props.feedbackCode))
      .withJson(body)
      .withAuthHeader()
      .put()
      .then(response => {
        if (response.status === 200) {
          props.onChange(props.feedbackCode, dueDate);
          showPostSetDueDateSnackbar(dueDate);
        } else {
          response.json().then(json => {
            showErrorSnackbar(response.status, json.title);
          });
        }
        setChangeDueDateLock(false);
        props.toggleModal();
      });
  };

  return (
    <Modal isOpen={props.isOpen} onToggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Select a due date for the feedback</ModalHeader>
      <ModalBody>
        <div style={{ width: "100%", textAlign: "center" }}>
          <div style={{ width: 125, display: "inline-block" }}>
            <CalendarPickerInput
              value={{ selectedDate: selectedDueDate, actual: datePickerActual } as any}
              onChange={date => {
                setSelectedDueDate(date);
              }}
              onChangeMonth={actualMonth => {
                setDatePickerActual(actualMonth);
              }}
              disabledDays={[
                {
                  before: new Date()
                }
              ]}
            />
          </div>
          <PrimaryButton
            application="cmThread"
            type="generic"
            text="Make Unset"
            neutral
            onClick={() => {
              setSelectedDueDate(undefined);
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => onEditDueDate(selectedDueDate)}>Save</Button>
        <Button onClick={props.toggleModal}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};
